module.exports = __webpack_public_path__ + "img/gerenciardispositivos.09a34907.jpg";